import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FormsInputModule } from '../../components/formsInput';
import { FormsSubmitModule } from '../../components/formsSubmit';
import { FormForTableNumberComponent } from './form-for-table-number.shared.component';

@NgModule({
    declarations: [
        FormForTableNumberComponent,
    ],
    imports: [
        CommonModule,
        FormsInputModule,
        FormsSubmitModule,
        ReactiveFormsModule,
    ],
    exports: [
        FormForTableNumberComponent,
    ],
})
export class FormForTableNumberModule { }
